function About() {
  return (
		<div className='about'>
			<h1>
				Each month, we create hundreds of resources for you to use in
				commercial and non-commercial projects.
			</h1>
			<div className='icons'>
				<img
					src='https://raw.githubusercontent.com/araltasher/svg-landing-page/master/images/xd_icon.png'
					alt='Adobe XD Icon'
				/>
				<img
					src='https://raw.githubusercontent.com/araltasher/svg-landing-page/master/images/sketch_icon.png'
					alt='SketchApp Icon'
				/>
			</div>
		</div>
  )
}
export default About